const clearDiscount = test => ({
    ...test,
    id_common_discount: null,
    id_special_discount: null,
    id_preloaded_discount: null,
    id_agreement: null,
    id_agreement_test_range: null,
    contract_number: null,
    price_Agremment: 0,
    discount: 0,
    amountDiscount: 0,
    auto_redeem: false
});

export const applySpecialDiscount = (tests, authorized) => tests.map(test => {
    const cleared = clearDiscount(test);
    const detail = (authorized.examProfileInclude || []).find(item =>
        test.id_profile != null
            ? item.id_profile != null && Number(item.id_profile) === Number(test.id_profile)
            : item.id_exam != null && Number(item.id_exam) === Number(test.id_exam));
    if (!detail && !(authorized.is_all_validate_in_exams && test.id_exam != null)) {
        return cleared;
    }
    return {
        ...cleared,
        id_special_discount: authorized?.id_special_discount ?? null,
        discount: Number(detail && detail?.percentage > 0 ? detail?.percentage : authorized?.percentage ?? 0),
        auto_redeem: true
    };
});

export const applyPreloadedDiscount = (tests, selected, isEligible) => tests.map(test => {
    const cleared = clearDiscount(test);
    return isEligible(test) ? {
        ...cleared,
        id_preloaded_discount: selected?.value ?? null,
        discount: Number(selected?.valuePercentage ?? 0),
        auto_redeem: true
    } : cleared;
});

export const getUpdateDiscountFields = test => ({
    id_special_discount: test?.id_special_discount > 0 ? test?.id_special_discount : null,
    id_preloaded_discount: test?.id_preloaded_discount > 0 ? test?.id_preloaded_discount : null,
    percentage_discount: Number(test?.discount || 0),
    amount_discount: Number(test?.amountDiscount || 0)
});
